<app-dialog [dialogWithInput]="dialog" [manualCloseManagement]="true" (closeEvent)="close()">
    <app-card>
        <div class="flex gap-5 m-b-8">
            <app-button (clickEvent)="currentTab = 'timelapse'" label="Ligne du temps"
                        [fill]="currentTab === 'timelapse' ? 'solid' : 'clear'" iconName="timeline">
            </app-button>
            <app-button (clickEvent)="currentTab = 'images'" label="Images"
                        [fill]="currentTab === 'images' ? 'solid' : 'clear'" iconName="photo">
            </app-button>
        </div>
        <div class="row" *ngIf="currentTab === 'images' && feet?.length > 0">
            <div class="col-12 col-lg-6 col-md-6 col-xl-6 text-right">
                <app-drawing-on-image [imageUrl]="values[0].pictureUrl"
                                      [drawingData]="feet[0].drawableData"
                                      [options]="drawableImageOptions[0]"
                                      (changedEvent)="drawingOnImageChanged($event, 0)"
                                      *ngIf="values[0].pictureUrl"></app-drawing-on-image>
            </div>
            <div class="col-12 col-lg-6 col-md-6 col-xl-6">
                <app-drawing-on-image [imageUrl]="values[1].pictureUrl"
                                      [options]="drawableImageOptions[1]"
                                      [drawingData]="feet[1].drawableData"
                                      (changedEvent)="drawingOnImageChanged($event, 1)"
                                      *ngIf="values[1].pictureUrl"></app-drawing-on-image>
            </div>
        </div>


        <div class="row" [style.visibility]="currentTab === 'timelapse' ? 'visible' : 'hidden'">
            <div class="col-12">
                <div class="d-flex gap-5">
                    <div class="flex-grow-1">
                        <div class="flex gap-5">
                            <div class="flex-grow-1">
                                <mat-slider [disabled]="!!intervalSubscription" min="0" [max]="sliderMaxValue"
                                            *ngIf="sliderMaxValue > 0" class="m-x-8" style="width: 95%;"
                                            [step]="frameRate / 100"
                                            [showTickMarks]="true">
                                    <input matSliderThumb [(ngModel)]="sliderValue" (valueChange)="refreshCanvas($event, 0);refreshCanvas($event, 1); ">
                                </mat-slider>
                            </div>
                            <div class="flex-shrink-0">
                                {{duration}} ms
                            </div>
                        </div>
                    </div>
                    <div class="flex-grow-0">
                        <app-button iconName="player-play-filled" (clickEvent)="start()" *ngIf="! intervalSubscription"></app-button>
                        <app-button iconName="player-pause-filled" (clickEvent)="pause()" *ngIf="intervalSubscription"></app-button>
                        <app-button iconName="multiplier-0-5x" (clickEvent)="speed = 1" [fill]="speed === 1 ? 'solid': 'clear'"></app-button>
                        <app-button iconName="multiplier-1x" (clickEvent)="speed = 2" [fill]="speed === 2 ? 'solid': 'clear'"></app-button>
                        <app-button iconName="multiplier-2x" (clickEvent)="speed = 4" [fill]="speed === 4 ? 'solid': 'clear'"></app-button>
                        <app-button iconName="rotate-clockwise-2" (clickEvent)="rotationChanged([0, 1])"></app-button>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-6 col-xl-6" style="text-align: right;">
                <div>
                    <app-button iconName="rotate-clockwise-2" (clickEvent)="rotationChanged([0])"></app-button>
                </div>
                <canvas style="border: 1px solid black; max-width: 100%;" #canvas1 height="500"></canvas>
            </div>
            <div class="col-12 col-lg-6 col-xl-6" style="text-align: left;">
                <div>
                    <app-button iconName="rotate-clockwise-2" (clickEvent)="rotationChanged([1])"></app-button>
                </div>
                <canvas style="border: 1px solid black; max-width: 100%;" #canvas2 height="500"></canvas>
            </div>
        </div>
    </app-card>
</app-dialog>